import { getUrlInt } from '@/helpers/UrlParam';

export const OBSTACLE_GAP_MIN = 3;
export const OBSTACLE_GAP_MAX = OBSTACLE_GAP_MIN + 6;
export const COLLECTIBLE_GAP_MIN = 2.25;
export const COLLECTIBLE_GAP_MAX = COLLECTIBLE_GAP_MIN + 5;

// export const ITEM_GAP_MIN = 1.25;
// export const ITEM_GAP_MAX = ITEM_GAP_MIN + 4;

export const CLOUD_GAP_MIN = 1;
export const CLOUD_GAP_MAX = CLOUD_GAP_MIN + 5;
export const CHARACTER_GAP_MIN = 7;
export const CHARACTER_GAP_MAX = CHARACTER_GAP_MIN * 2;

export const COLLECTIBLE_HIGHER_OFFSET = 1.5;

export const SPAWN_DISTANCE = 10;
export const SCORE_LIMIT = getUrlInt('scoreLimit', 5);
export const ENDING_DISTANCE = 8;

const cowAspect = 875 / 556;
export const itemSizes = {
  // colleectibles
  barley: [0.5, 0.5],
  truck: [1, 0.75],
  poo: [0.5, 0.5],

  // obstacles
  haybale: [2 * 0.4, 1 * 0.4],
  cow: [cowAspect * 0.6, 0.6],
  scarecrow: [0.3, 1],
  cloud: [0.75, 0.75],
  wasps: [0.3, 0.4],
};

export const beerConfig = {
  player: {
    size: {
      x: 0.5,
      y: 1,
    },
    jumpForce: 7,
    gravity: -20,
    acceleration: 2,
    maxVelocity: 1.5,
  },
  camera: {
    offset: {
      // x: 0,
      // y: 0,
      x: 0.7,
      y: 1.3,
      z: 4.75 * 1,
    },
  },
  areas: [
    {
      idx: 0,
      name: 'Area 1',
      speed: 1,
      // numClouds: 50,
      // numCharacters: 10,
      // numObstacles: 10,
      // numCollectibles: 10,
      itemGap: {
        min: 1.25,
        max: 4,
      },
      obstacles: [
        {
          type: 'haybale',
        },
        {
          type: 'cow',
          opts: {
            isCrashable: true,
            sprite: {
              rows: 2,
              cols: 4,
              frames: 6,
              fps: 6,
            },
          },
        },
      ],
      collectibles: [
        {
          type: 'barley',
          height: {
            min: 1.5,
            max: 1.75,
          },
          canSpawnAboveObstacle: true,
        },
      ],
      characters: ['bird'],
      characterScale: 0.4,
      characterRangeZ: [-4, -2],
      endings: [
        { type: 'sign', offset: [0, 0, 0], size: [1, 1] },
        { type: 'shed', offset: [0, -0.4, -0.001], size: [2.75, 2.75] },
      ],
    },
    {
      idx: 1,
      name: 'Area 2',
      speed: 1.25,
      // numClouds: 50,
      // numCharacters: 50,
      // numObstacles: 10,
      // numCollectibles: 10,
      itemGap: {
        min: 2.5,
        max: 5,
      },
      obstacles: [
        {
          type: 'scarecrow',
          height: {
            min: -0.05,
            max: -0.05,
          },
          opts: {
            isCrashable: true,
          },
        },
      ],
      collectibles: [
        {
          type: 'poo',
          height: {
            min: 0,
            max: 1.75,
          },
          canSpawnAboveObstacle: true,
        },
      ],
      characters: ['dog1', 'dog2'],
      characterScale: 0.8,
      characterRangeZ: [-4, -2],
      endings: [{ type: 'tractor', offset: [0, -0.08, 0], size: [2.5, 2.5] }],
    },
    {
      idx: 2,
      name: 'Area 3',
      speed: 1.5,
      // numClouds: 0,
      // numCharacters: 10,
      // numObstacles: 10,
      // numCollectibles: 10,
      itemGap: {
        min: 2.5,
        max: 5,
      },
      obstacles: [
        {
          type: 'cloud',
          height: {
            min: 1.5,
            max: 2,
          },
          opts: {
            isStandable: false,
            isBlocking: false,
            isCrashable: true,
            sprite: {
              rows: 2,
              cols: 4,
              frames: 5,
              fps: 6,
            },
          },
        },
        {
          type: 'wasps',
          height: {
            min: 0.1,
            max: 0.3,
          },
          opts: {
            isStandable: false,
            isBlocking: false,
            isCrashable: true,
            sprite: {
              rows: 2,
              cols: 2,
              frames: 4,
              fps: 6,
            },
          },
        },
      ],
      collectibles: [
        {
          type: 'truck',
          animateOut: false,
          opts: {
            isStandable: true,
            isBlocking: true,
          },
        },
      ],
      characters: [],
      characterScale: 1,
      characterRangeZ: [-10, -2],
      endings: [
        { type: 'person', offset: [-0.5, 0, -1], size: [1, 1] },
        { type: 'pub', offset: [0, -0.1, 0], size: [3.5, 3.5] },
      ],
    },
  ],
};
